// src/App.jsx

import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';

// --- Layout Components ---
import Sidebar from './Sidebar.jsx';
import Topbar from './Topbar.jsx';

// --- Import All Page Components ---
// Note: In a real app, you might lazy load these for better performance.
import Dashboard from './pages/Dashboard';
import LoginPage from './pages/LoginPage';
import UsersPage from './pages/UsersPage';
import UserFormPage from './pages/UserFormPage.jsx';


import CategoriesPage from './pages/grocery/CategoriesPage';

import GoodsReceivedNotesPage from './pages/GoodsReceivedNotesPage';
import AddGrnPage from './pages/AddGrnPage';




import Banner from './pages/grocery/banner';

import Customers from './pages/Customers.jsx';
import ExpensesPage from './pages/ExpensesPage.jsx';
import AddExpensePage from './pages/AddExpensePage.jsx';
import OrderList from './pages/OrderList.jsx';
import DeliveryPersonManagement from './pages/DeliveryPersonManagement.jsx';
import AssignDelivery from './components/AssignDelivery.jsx';







import GroceryProductList from './pages/grocery/GroceryProductList';
import AddGroceryProduct from './pages/grocery/AddGroceryProduct.jsx';
import EditGroceryProduct from './pages/grocery/EditGroceryProduct.jsx';



// --- Layout Component ---
const AppLayout = ({ logout, user }) => (
  <div style={{ display: 'flex', height: '100vh', width: '100vw' }}>
    <Sidebar />
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Topbar logout={logout} user={user} />
      <main style={{ flex: 1, overflowY: 'auto', backgroundColor: '#f0f2f5', padding: '1.5rem' }}>
        {/* Pass the user object to all child routes rendered by the Outlet */}
        <Outlet context={{ user }} /> 
      </main>
    </div>
  </div>
);

// --- Main Application Component ---
function App() {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    checked: false,
    user: null,
  });

  useEffect(() => {
    try {
      const user = localStorage.getItem('user');
      if (user) {
        setAuthState({ isAuthenticated: true, user: JSON.parse(user), checked: true });
      } else {
        setAuthState({ isAuthenticated: false, user: null, checked: true });
      }
    } catch (error) {
      console.error("Failed to parse user from localStorage:", error);
      localStorage.removeItem('user');
      setAuthState({ isAuthenticated: false, user: null, checked: true });
    }
  }, []);

  const login = (userData) => {
    localStorage.setItem('user', JSON.stringify(userData));
    setAuthState({ isAuthenticated: true, user: userData, checked: true });
  };

  const logout = () => {
    localStorage.removeItem('user');
    setAuthState({ isAuthenticated: false, user: null, checked: true });
  };

  if (!authState.checked) {
    return <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Loading...</div>;
  }

  // --- Route Protection Components (Authentication Only) ---
  const ProtectedRoute = ({ children }) => authState.isAuthenticated ? children : <Navigate to="/login" replace />;
  const AuthRoute = ({ children }) => authState.isAuthenticated ? <Navigate to="/dashboard" replace /> : children;

  return (
    // --- AuthorizationProvider and PermissionRoute have been removed ---
    <Router>
      <Routes>
        <Route path="/login" element={<AuthRoute><LoginPage login={login} /></AuthRoute>} />
        
        <Route path="/" element={<ProtectedRoute><AppLayout logout={logout} user={authState.user} /></ProtectedRoute>}>
          
          <Route index element={<Navigate to="/dashboard" replace />} />

          {/* --- All Routes are now directly rendered without permission checks --- */}
          <Route path="dashboard" element={<Dashboard />} />
          
          {/* User Management */}
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<UserFormPage />} />
         
         
          <Route path="customers" element={<Customers />} />
          
          
       
          
          {/* Categories */}
          <Route path="categories" element={<CategoriesPage />} />
          
          {/* Food & Packages */}
     
         

          {/* Inventory */}
          <Route path="grns" element={<GoodsReceivedNotesPage />} />
          <Route path="grns/add" element={<AddGrnPage />} />

         


          
          {/* Standalone Features */}
          <Route path="banner" element={<Banner />} />
          <Route path="orders" element={<OrderList />} />
      
        

          {/* Grocery & Party Specific Routes */}
          <Route path="groceryproduct" element={<GroceryProductList />} />
          <Route path="groceryproduct/add" element={<AddGroceryProduct />} />
  
           <Route path="groceryproduct/edit/:id" element={<EditGroceryProduct />} /> 
          

          <Route path="expenses" element={<ExpensesPage />} />
          <Route path="expenses/add" element={<AddExpensePage />} />
          <Route path="expenses/edit/:id" element={<AddExpensePage />} />
          <Route path="delivery-persons" element={<DeliveryPersonManagement />} />
          <Route path="AssignDelivery" element={<AssignDelivery />} />
     
                   
          
        </Route>

        <Route path="*" element={<Navigate to={authState.isAuthenticated ? '/dashboard' : '/login'} replace />} />
      </Routes>
    </Router>
  );
}

export default App;